<div class="ss-toast" *ngIf="toastMessage" [class.ss-toast-error]="toastType === 'error'">{{ toastMessage }}</div>

<div class="store-page">
  <div class="page-header-row">
    <h1 class="ss-page-title">Stores</h1>
    <button class="ss-btn ss-btn-primary" data-bs-toggle="modal" data-bs-target="#staticBackdrop">Add Store</button>
  </div>

  <div class="ss-filter-bar">
    <input class="ss-input" style="max-width:260px" type="text" placeholder="Search by name or email…"
      [(ngModel)]="storeSearchTerm" (ngModelChange)="onSearchChange()" />
  </div>

  <div class="ss-loading" *ngIf="loading"><div class="ss-spinner"></div> Loading…</div>

  <div class="store-table-wrap" *ngIf="!loading && filteredStores().length > 0">
    <table class="ss-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>IP</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let store of paginatedStores" [class.deactivated-row]="!store.isActive">
          <td>{{ store.name }}</td>
          <td>{{ store.email }}</td>
          <td style="color:var(--color-text-muted)">{{ store.ipAddress || '—' }}</td>
          <td>
            <div class="row-actions">
              <ng-container *ngIf="store.isActive; else inactiveActions">
                <button class="ss-btn ss-btn-secondary ss-btn-sm" (click)="openStoreAdmins(store.storeId)">Admins</button>
                <button class="ss-btn ss-btn-secondary ss-btn-sm" (click)="openAddUserModal(store.storeId)">Add User</button>
                <button class="ss-btn ss-btn-danger ss-btn-sm" (click)="deleteStore(store.storeId)">Deactivate</button>
              </ng-container>
              <ng-template #inactiveActions>
                <span style="font-size:12px;color:var(--color-text-muted)">Deactivated</span>
                <button class="ss-btn ss-btn-success ss-btn-sm" (click)="activateStore(store.storeId)">Activate</button>
              </ng-template>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="ss-empty" *ngIf="!loading && filteredStores().length === 0">No stores found.</div>

  <div class="pagination-bar" *ngIf="filteredStores().length > pageSize && !loading">
    <button class="ss-btn ss-btn-secondary ss-btn-sm" (click)="previousPage()" [disabled]="pageNumber === 1">Previous</button>
    <button *ngFor="let page of visiblePages()" class="ss-btn ss-btn-secondary ss-btn-sm"
      [style.background]="page === pageNumber ? 'var(--color-accent)' : ''"
      [style.color]="page === pageNumber ? 'white' : ''"
      (click)="goToPage(page)">{{ page }}</button>
    <button class="ss-btn ss-btn-secondary ss-btn-sm" (click)="nextPage()" [disabled]="pageNumber >= totalPages()">Next</button>
  </div>
</div>

<!-- Add Store Modal -->
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add Store</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="onModalClose(); addStoreForm.resetForm()"></button>
      </div>
      <form #addStoreForm="ngForm" novalidate>
        <div class="modal-body">
          <div class="mb-3"><label class="form-label">Name</label>
            <input type="text" class="form-control" name="storeName" [(ngModel)]="storeName" placeholder="Fast Pharm" [disabled]="disabled" /></div>
          <div class="mb-3"><label class="form-label">Email</label>
            <input type="text" class="form-control" name="storeEmail" [(ngModel)]="storeEmail" placeholder="name@example.com"
              required pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" #storeEmailCtrl="ngModel" [disabled]="disabled" />
            <div class="text-danger" *ngIf="storeEmailCtrl.invalid && storeEmailCtrl.touched">
              <small *ngIf="storeEmailCtrl.errors?.['required']">Email required</small>
              <small *ngIf="storeEmailCtrl.errors?.['pattern']">Enter a valid email</small>
            </div></div>
          <div class="mb-3"><label class="form-label">Address</label>
            <input type="text" class="form-control" name="storeAddress" [(ngModel)]="storeAddress" [disabled]="disabled" /></div>
          <div class="mb-3"><label class="form-label">Contact</label>
            <input type="text" class="form-control" name="storeContact" [(ngModel)]="storeContact" [disabled]="disabled" /></div>
          <div class="mb-3"><label class="form-label">IP Address</label>
            <input type="text" class="form-control" name="storeIpAddress" [(ngModel)]="storeIpAddress" [disabled]="disabled" /></div>
          <div *ngIf="token && isToken" class="token-display">
            <label class="form-label">Token</label>
            <input type="text" class="form-control" [value]="token" readonly />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="ss-btn ss-btn-secondary" data-bs-dismiss="modal" (click)="onModalClose(); addStoreForm.resetForm()">Close</button>
          <button type="button" class="ss-btn ss-btn-primary" (click)="addStore()" [disabled]="disabled || addStoreForm.invalid">Add Store</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Add User to Store Modal -->
<div class="modal fade" id="addUserModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add User to Store</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="onModalClose(); addUserForm?.resetForm()"></button>
      </div>
      <form #addUserForm="ngForm" novalidate>
        <div class="modal-body">
          <div class="mb-3"><label class="form-label">Name</label>
            <input type="text" class="form-control" name="name" [(ngModel)]="name" placeholder="John Doe" required [disabled]="disabled" /></div>
          <div class="mb-3"><label class="form-label">Email</label>
            <input type="text" class="form-control" name="email" [(ngModel)]="email" placeholder="name@example.com"
              required pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" #emailCtrl="ngModel" [disabled]="disabled" />
            <div class="text-danger" *ngIf="emailCtrl && emailCtrl.invalid && emailCtrl.touched">
              <small *ngIf="emailCtrl.errors?.['required']">Email required</small>
              <small *ngIf="emailCtrl.errors?.['pattern']">Enter a valid email</small>
            </div></div>
          <div class="mb-3"><label class="form-label">IP Address</label>
            <input type="text" class="form-control" name="ipAddress" [(ngModel)]="ipAddress" [disabled]="disabled" /></div>
          <div class="mb-3"><label class="form-label">Role</label>
            <select class="form-select" name="role" [(ngModel)]="selectedRole" [disabled]="disabled">
              <option value="" disabled selected>Select role</option>
              <option value="StoreAdmin">Store Admin</option>
              <option value="StoreUser">Store User</option>
            </select></div>
          <div *ngIf="username" style="background:var(--color-surface);border:1px solid var(--color-border);border-radius:6px;padding:12px;margin-top:12px">
            <label class="form-label">Credentials</label>
            <input class="form-control" [value]="token" readonly style="margin-bottom:8px;font-family:monospace;font-size:12px" />
            <div style="display:flex;gap:8px;margin-bottom:8px">
              <input class="form-control" [value]="username" readonly style="font-family:monospace;font-size:12px" />
              <input class="form-control" [value]="password" readonly style="font-family:monospace;font-size:12px" />
            </div>
            <button class="ss-btn ss-btn-secondary ss-btn-sm" (click)="copyToken()">Copy All</button>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="ss-btn ss-btn-secondary" data-bs-dismiss="modal" (click)="onModalClose(); addUserForm?.resetForm()">Close</button>
          <button type="button" class="ss-btn ss-btn-primary" (click)="addUser()" [disabled]="disabled || !selectedRole || addUserForm.invalid">Add User</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Store Admins Modal -->
<div class="modal fade" id="storeAdminsModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Store Admins</h5>
        <button class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div class="ss-loading" *ngIf="isLoadingAdmins"><div class="ss-spinner"></div> Loading…</div>
        <div class="ss-empty" *ngIf="!isLoadingAdmins && storeAdmins.length === 0">No admins found.</div>
        <table class="table" *ngIf="storeAdmins.length > 0">
          <thead><tr><th>Name</th><th>Token</th><th></th></tr></thead>
          <tbody>
            <tr *ngFor="let admin of storeAdmins">
              <td>{{ admin.name }}</td>
              <td style="font-family:monospace;font-size:12px">{{ maskApiKey(admin.apiKey) }}</td>
              <td><button class="ss-btn ss-btn-secondary ss-btn-sm" (click)="copyAdminToken(admin.apiKey)">Copy</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
